"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var Model_1 = require("../../Model");
var LINEHAUL_DELAY_STATUS;
(function (LINEHAUL_DELAY_STATUS) {
    LINEHAUL_DELAY_STATUS["ON_TIME"] = "ON_TIME";
    LINEHAUL_DELAY_STATUS["MIN_15_DELAY"] = "MIN_15_DELAY";
    LINEHAUL_DELAY_STATUS["MIN_30_DELAY"] = "MIN_30_DELAY";
})(LINEHAUL_DELAY_STATUS = exports.LINEHAUL_DELAY_STATUS || (exports.LINEHAUL_DELAY_STATUS = {}));
var LinehaulTour = /** @class */ (function () {
    function LinehaulTour() {
    }
    /**
     * Creates a linehaul tour for a driver that has just scanned a shipment. For driver app's consumption
     * Validates if shipment is part of the region before creating the linehaul tour. Throws an error if not.
     * @param {string} barcode The shipment's barcode.
     * @param {string} licensePlate The license plate of the vehicle used in the linehaul.
     * @returns {Promise<ICreateLinehaulTourResponse>} All database elements created
     * the tour, collations, stops, ledgers, and estimations.
     */
    LinehaulTour.createTour = function (barcode, licensePlate) {
        return Model_1.Model.makeRequest("/spatial/functions/linehaul/tour/create", Model_1.METHOD.POST, { barcode: barcode, licensePlate: licensePlate });
    };
    /**
     * Start the driver's linehaul tour.
     * Invoked when driver is done loading shipments for linehaul and is ready to embark.
     * For driver app's consumption
     */
    LinehaulTour.startTour = function () {
        return Model_1.Model.makeRequest("/spatial/functions/linehaul/tour/start", Model_1.METHOD.GET);
    };
    /**
     * Ends the driver's linehaul tour.
     * Invoked when driver has arrived.
     * For driver app's consumption
     */
    LinehaulTour.finishTour = function () {
        return Model_1.Model.makeRequest("/spatial/functions/linehaul/tour/finish", Model_1.METHOD.GET);
    };
    /**
     * Fetch today's linehaul tour for driver.
     * For driver app's consumption
     */
    LinehaulTour.getLinehaulTour = function () {
        return Model_1.Model.makeRequest("/spatial/functions/linehaul/get-linehaul-tour-for-driver", Model_1.METHOD.GET);
    };
    /**
     * Gets the number of linehaul tours being handled and the longest delay, if any, per subcontractor.
     * @param {string} date The date for the specified query. If a date is not supplied, uses CURRENT_DATE instead
     * @returns {Promise<ILinehaulTourCountPerSubco[]>} The amount and DELAY_STATUS of all linehaul tours for subcoId and date.
     */
    LinehaulTour.getLinehaulTourCountForSubco = function (date) {
        var dateString = '';
        if (date) {
            dateString = "?date=" + moment_1.default(date).format('YYYY-MM-DD');
        }
        return Model_1.Model.makeRequest("/delivery/functions/linehaul/tours-per-subco" + dateString, Model_1.METHOD.GET);
    };
    /**
     * Verifies whether the license plate is usable by the Back-End.
     * Returns a boolean value to codify this.
     * @param {string} licensePlate the plate number to be verified
     * @returns {Promise<boolean>}
     */
    LinehaulTour.isLicensePlateValid = function (licensePlate) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Model_1.Model.makeRequest("/delivery/functions/verify/license-plate", Model_1.METHOD.PUT, {
                                licensePlate: licensePlate,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a view of all the linehaul tours and estimation times for a specified subcontractor
     * Also lists their DELAY_STATUS, i.e, if a tour is on time, has a 15+ min delay, or a 30+ min delay
     * @param { number } subcoId The subcontractor id to query
     * @param { date } The date for the specified query. If a date is not supplied, uses CURRENT_DATE instead
     * @returns { Promise<ILinehaulTrackingResponseRow[]> } The list of linehaul tours for subcoId and date
     */
    LinehaulTour.getLinehaulTracking = function (subcoId, date) {
        var dateString = '';
        if (date) {
            dateString = "?date=" + moment_1.default(date).format('YYYY-MM-DD');
        }
        return Model_1.Model.makeRequest("/delivery/functions/linehaul/tracking/" + subcoId + dateString, Model_1.METHOD.GET);
    };
    /**
     * Gets the latest recorded location and destination of a linehaul tour's designated driver in latitude and longitude
     * @param { number } tourId The linehaul tour id to query
     * @returns { Promise<IDriverLocationInLinehaulTour> } Driver's last recorded location and destination
     * in latitude and longitude
     */
    LinehaulTour.getDriverLocationInLinehaulTour = function (tourId) {
        return Model_1.Model.makeRequest("/delivery/functions/linehaul/driver-location/" + tourId, Model_1.METHOD.GET);
    };
    return LinehaulTour;
}());
exports.LinehaulTour = LinehaulTour;
